import { useTranslation } from "react-i18next";
import { Box, Typography, Skeleton, Tooltip } from "@mui/material";

import {
  PaymentDataBaseIcon,
  PaymentMoneyIcon,
  PaymentArrowCircleDownLeftIcon,
  PaymentBankIcon,
  PaymentOverViewTooltipIcon,
} from "../../../../../assets/icons/MUI/PaymentIcons";
import { OverviewPaymentType } from "../../../payment.types";

const PaymentCard = ({ payment }: { payment: OverviewPaymentType }) => {
  const { t } = useTranslation();

  const { key, amount, currency } = payment;

  const iconMap = {
    allPayment: PaymentDataBaseIcon,
    onTheWayToYourAccount: PaymentMoneyIcon,
    paidToGoalngo: PaymentArrowCircleDownLeftIcon,
    receivedToYourAccount: PaymentBankIcon,
  };

  const tooltipMap = {
    allPayment: PaymentOverViewTooltipIcon,
    onTheWayToYourAccount: PaymentOverViewTooltipIcon,
    paidToGoalngo: PaymentOverViewTooltipIcon,
    receivedToYourAccount: PaymentOverViewTooltipIcon,
  };

  const Icon = key && iconMap[key as keyof typeof iconMap];

  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #EAECF0",
        background: "var(--Gray-White, #FFF)",
        display: "flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "16px",
        width: "calc(25% - 12px)",
      }}
    >
      {Icon && <Icon />}
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "6px" }}>
        <Typography
          component="span"
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "30px",
          }}
        >
          {`${amount / 100} ${currency.toUpperCase()}`}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: "4px", justifyContent: "space-between" }}>
          <Typography
            component="span"
            sx={{
              color: "var(--Dark---600, #707070)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
            }}
          >
            {t(`pages.payment.overview.dashboard.${key}`)}
          </Typography>
          {tooltipMap[key as keyof typeof tooltipMap] && (
            <Tooltip title={t(`pages.payment.overview.dashboard.tooltip.${key}`)}>
              <span style={{ display: "inline-flex", cursor: "help" }}>
                <PaymentOverViewTooltipIcon />
              </span>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentCard;

export const PaymentCardLoading = () => {
  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #EAECF0",
        background: "var(--Gray-White, #FFF)",
        display: "flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "16px",
        gridColumn: "span 1",
        gridRow: "span 1",
      }}
    >
      <Skeleton
        variant="rounded"
        sx={{
          width: "40%",
          maxWidth: "56px",
          aspectRatio: "1/1",
        }}
      />
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "6px", width: "100%" }}>
        <Skeleton
          variant="text"
          sx={{
            width: "40%",
            maxWidth: "80px",
            height: "30px",
          }}
        />
        <Skeleton
          variant="text"
          sx={{
            width: "80%",
            maxWidth: "120px",
            height: "20px",
          }}
        />
      </Box>
    </Box>
  );
};
